<template>
	<div class="document-type-grid">
		<div v-for="cat in categories" :key="cat.label" class="doc-type-lozenge">
			<img :src="cat.icon" :alt="cat.label" class="lozenge-icon" />
			<p class="lozenge-label">{{ cat.label }}</p>
		</div>
	</div>
</template>

<script>
import Helpers from '../../mixins/Helpers';

const categoryNames = ['Home', 'Family', 'Banking', 'Investments', 'Vehicles', 'Travel', 'Work', 'Tax', 'Health', 'Subscriptions', 'Pets', 'Important', 'Personal', 'Other'];

export default {
	name: 'DocumentTypeGrid',
	mixins: [Helpers],
	computed: {
		categories() {
			return categoryNames.map(name => ({
				label: name,
				icon: this._getDocumentCategoryImage(name)
			}));
		}
	}
};
</script>

<style scoped>
.document-type-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.doc-type-lozenge {
	background: white;
	border-radius: 8px;
	padding: 8px;
	display: flex;
	align-items: center;
	gap: 4px;
	width: calc(50% - 4px);
	height: 36px;
	overflow: hidden;
}

.lozenge-icon {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	flex-shrink: 0;
	object-fit: cover;
}

.lozenge-label {
	font-size: 11px;
	font-weight: bold;
	color: var(--brand-purple);
	margin: 0;
	white-space: nowrap;
	line-height: 12px;
}
</style>
